/**
 * Enemy float-HP escalate (맹공) badge — same glyph language as HUD 「맹공 ×n」.
 * Boss/colossus uses elite status line only; adds/chargers/brutes attach here.
 */

/** Matches `.raid-escalate-icon` in raid HUD markup. */
export const ENEMY_ESCALATE_ICON_GLYPH = "▲";

/** Centered under float HP bar (local chrome space). */
export function enemyEscalateBadgeLocalPos(opts: {
  hpY: number;
  barH: number;
}): { x: number; y: number } {
  return {
    x: 0,
    y: opts.hpY + opts.barH * 0.5 + 7,
  };
}

/** Visible when stage stacks > 0 and float HP chrome is showing. */
export function shouldShowEnemyEscalateBadge(opts: {
  team: 0 | 1;
  escalateStacks: number;
  floatHpVisible: boolean;
  alive: boolean;
}): boolean {
  return (
    opts.team === 1 &&
    opts.alive &&
    opts.floatHpVisible &&
    opts.escalateStacks > 0
  );
}

export function enemyEscalateBadgeText(stacks: number): string {
  const n = Math.max(0, Math.trunc(stacks));
  return `${ENEMY_ESCALATE_ICON_GLYPH}${n}`;
}
